export default __webpack_public_path__ + "images/AA.5e626b9.png";